import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, User } from 'lucide-react';
import Reveal from '@/components/site/Reveal';
import SectionHeading from '@/components/site/SectionHeading';
import api from '@/lib/api';
import { formatDate } from '@/lib/format';

export default function BlogPreview() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get('/blog', { params: { limit: 3 } }).then((res) => setPosts((res.data || []).slice(0, 3))).catch(() => {});
  }, []);

  return (
    <section data-testid="home-blog-preview" className="py-20 md:py-28 bg-slate-50">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <Reveal>
            <SectionHeading kicker="Insights" title="From the Cespedis desk." subtitle="Market reports, leasing playbooks, and property management best practices." />
          </Reveal>
          <Reveal delay={120}>
            <Link to="/blog" className="hidden md:inline-flex items-center gap-2 text-sm font-semibold text-[#144726] hover:text-[#C6A35B] transition-colors link-gold" data-testid="blog-preview-view-all">
              All articles <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={i * 80}>
              <Link to={`/blog/${p.slug || p.id}`} data-testid="blog-preview-card" className="group flex h-full flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm hover:shadow-md transition-shadow">
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={p.cover_image} alt={p.title} className="h-full w-full object-cover transition-transform duration-[700ms] group-hover:scale-105" />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <div className="flex items-center gap-4 text-xs text-slate-500">
                    <span className="inline-flex items-center gap-1"><Calendar className="h-3.5 w-3.5" />{formatDate(p.published_at)}</span>
                    <span className="inline-flex items-center gap-1"><User className="h-3.5 w-3.5" />{p.author}</span>
                  </div>
                  <h3 className="mt-3 font-display text-xl font-semibold text-[#144726] tracking-tight line-clamp-2">{p.title}</h3>
                  <p className="mt-3 text-sm text-slate-600 line-clamp-3">{p.excerpt}</p>
                  <p className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#144726] group-hover:text-[#C6A35B] transition-colors">Read article <ArrowRight className="h-4 w-4" /></p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
